import { removeHash } from '~/_shared/components/colorPicker/colorPicker.helpers';
import { type HeatMap } from '~/_shared/types/heatmap/heatMap.types';

type HeatMapPalette = {
  colors: ReadonlyArray<string>;
  single: string;
};

const presets = [{
  colors: ['0000FF', '00FFFF', '00B91C', 'FFFF00', 'FF0000'],
  single: 'FF0000',
}, {
  colors: ['000004', '420A68', 'DD513A', 'FCA50A', 'FCFFA4'],
  single: '420A68',
}, {
  colors: ['440154', '2A788E', '22A884', '7AD151', 'FDE725'],
  single: '7AD151',
}, {
  colors: ['2B83BA', 'ABDDA4', 'FFFFBF', 'FDAE61', 'D7191C'],
  single: '2B83BA',
}, {
  colors: ['0D0887', '7B02A8', 'CB4679', 'F89440', 'F0F921'],
  single: 'F0F921',
}] as const satisfies ReadonlyArray<HeatMapPalette>;

export const resetHeatMapItems = (items: ReadonlyArray<HeatMap>): ReadonlyArray<HeatMap> =>
  items.map((item, index) => {
    const preset = presets[index % presets.length] ?? presets[0];

    return {
      ...item,
      radius: 50,
      opacity: 50,
      threshold: 50,
      isGradient: true,
      colors: preset.colors,
      singleColor: preset.single,
    };
  });

export const getHeatMapPresetColor = (usedColors: string[]): HeatMapPalette => {
  const unusedPreset = presets.find(preset => usedColors.every(usedColor =>
    removeHash(usedColor.toLowerCase()) !== removeHash(preset.single.toLowerCase()),
  ));

  return unusedPreset ?? presets[getRandomIndex(presets.length - 1)] ?? presets[0];
};

const getRandomIndex = (max: number) =>
  Math.floor(Math.random() * Math.floor(max));
